import React, { useEffect, useState, useRef } from 'react'
import { formatTime } from '../utils/formatTime'
import { getCurrentLocationOffset } from '../utils/GetCurrentLocationOffset'
import CopyIcon from '../Icons/CopyIcon'
import Focus from '../Icons/Focus'
import FocusPresetPopup from '../Popups/FocusPresetPopup'
import PlayIcon from './../Icons/PlayIcon';
import PauseIcon from '../Icons/PauseIcon'
import AddIcon from '../Icons/AddIcon'
import DownArrowIcon from '../Icons/DownArrowIcon'
import TeamIcon from '../Icons/TeamIcon'
import PersonIcon from '../Icons/PersonIcon'
import SettingsIcon from '../Icons/SettingsIcon'
import CreateTeamsPopup from '../Popups/CreateTeamsPopup'

const TopBar = ({ activeMenu }) => {
  const audioFiles = [
    { name: "Birds-singing-forest", src: "/audio/birds-singing-forest.mp3" },
    { name: "Piano", src: "/audio/piano.mp3" },
    { name: "Rain-in-forest", src: "/audio/rain-in-forest.mp3" },
    { name: "Water-in-forest", src: "/audio/water-in-forest.mp3" },
    { name: "Wind-tall-grass", src: "/audio/wind-tall-grass.mp3" }
  ];

  const [time, setTime] = useState(new Date());
  const [format, setFormat] = useState(false);
  const [showFocus, setShowFocus] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openTeamsPopup, setTeamsOpenPopup] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showTeams, setShowTeams] = useState(false)

  // Audio reference
  const audioRef = useRef(null);

  const Title = () => {
    switch (activeMenu) {
      case "timezone":
        return "Timezones";
      case "pomodoro":
        return "Pomodor";
      case "dailyplanner":
        return "Daily Planner";
      case "worldtimer":
        return "World Timer";
      case "timer":
        return "Timer";
      case "stopwatch":
        return "Stop Watch";
      default:
        break;
    }
  };

  const handleAudioChange = (e) => {
    const selected = e.target.value;
    setSelectedAudio(selected);
  };

  const handleFocusPopup = () => {
    setShowFocus(false)
    setOpenPopup(true);
  };

  const handleTeamsPopup = () => {
    setShowTeams(false)
    setTeamsOpenPopup(true);
  }

  const closePopup = () => {
    setOpenPopup(false);
    setShowFocus(true)
  };
  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    if (selectedAudio && audioRef.current) {
      audioRef.current.load();
      audioRef.current.play();
    }
  }, [selectedAudio]);

  return (
    <>
      {openPopup && (
        <FocusPresetPopup
          handleAudioChange={handleAudioChange}
          selectedAudio={selectedAudio}
          closePopup={closePopup}
          audioFiles={audioFiles}
        />
      )}
      {openTeamsPopup && (
        <CreateTeamsPopup
          model={''}
          handleChange={''}
          closePopup={() => setTeamsOpenPopup(false)}
        />
      )}
      <div className='relative flex min-h-[36px] justify-between gap-2 border-b border-b-zinc-800 bg-zinc-900 text-xs sm:gap-0'>
        <div className='flex items-stretch'>
          <div className='flex items-center px-2 bg-zinc-800 hover:bg-zinc-700 sm:hidden'>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu">
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </div>
          <button className='hidden lg:block '></button>
          <div className='relative flex items-center text-sm rounded-lg text-zinc-500'>
            <span className='py-2 px-3'>{Title()}<span className='pl-2'>/</span></span>
            {/* Teams Button */}
            <button onClick={() => setShowTeams(!showTeams)} className='flex justify-center gap-2 items-center  px-2 py-1 rounded-lg hover:bg-neutral-800'>
              <TeamIcon />
              <span className=''>Select Team</span><span className={`${showTeams && "rotate-180"}`}><DownArrowIcon /></span>
            </button>
            {/* Drop Down */}
            {showTeams &&
              <div className='absolute z-20 border rounded-md border-zinc-700 bg-zinc-900  top-10 left-24 shadow-2xl'>
                <div className='flex flex-col'>
                  {/* Personal Account Button */}
                  <button className='flex  items-center bg-zinc-800/50 px-2 py-1.5 hover:bg-zinc-600/40'>
                    <div className='flex items-center justify-center gap-2'>
                      <PersonIcon />
                      <span className='text-zinc-500'>Personal&nbsp;Account</span>
                    </div>

                  </button>
                  {/* Teams Button */}
                  <button className='flex justify-between gap-10 items-center px-2 py-1.5 hover:bg-zinc-600/40'>
                    <div className='flex w-28 items-center gap-2'>
                      <TeamIcon />
                      <span className='text-zinc-500 '>FrontEnd</span>
                    </div>
                    <span className='hover:text-zinc-100'>
                      <SettingsIcon />
                    </span>
                  </button>
                  {/* Create New Team Button */}
                  <button onClick={handleTeamsPopup} className="flex items-center w-full gap-1.5 bg-zinc-800/50 px-2 py-1.5 text-xs uppercase tracking-wider hover:bg-zinc-600/40 hover:text-zinc-300">
                    <AddIcon />
                    <span className='text-zinc-500 '>
                      CREATE TEAM
                    </span>
                  </button>
                </div>
              </div>
            }

          </div>

        </div>
        <div className='flex text-sm'>
          {selectedAudio && (
            <div className='flex items-center space-x-4'>
              <audio ref={audioRef} loop className='hidden'>
                <source src={selectedAudio} type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <button
                onClick={togglePlayPause}
                className='rounded-lg text-zinc-500 hover:text-zinc-400 focus:outline-none'
              >
                {isPlaying ? (
                  <PauseIcon />
                ) : (
                  <PlayIcon />
                )}
              </button>

              {/* Wave Animation */}
              {isPlaying ? (
                <div className="flex space-x-1 wave-animation">
                  {[...Array(10)].map((_, i) => (
                    <div
                      key={i}
                      className="w-[1px] h-2 bg-zinc-400 animate-pulse"
                      style={{
                        animationDelay: `${i * 0.1}s`,
                        animationDuration: '1s',
                      }}
                    ></div>
                  ))}
                </div>
              ) : (<div className='flex space-x-1'>
                {[...Array(10)].map((_, i) => (
                  <div
                    key={i}
                    className="w-[1px] h-2 bg-zinc-400"

                  ></div>
                ))}
              </div>)
              }
            </div>

          )}


          <button onClick={() => setShowFocus(!showFocus)} className='flex items-center px-2 text-sm text-zinc-500 hover:bg-zinc-800'>
            <Focus />
            <span className='hidden ml-1 sm:inline'>Focus</span>
          </button>

          {showFocus && (
            <div className='absolute z-20 border rounded-md border-zinc-700 shadow-2xl bg-zinc-900 w-44 top-10 right-56'>
              <div className='flex flex-col'>
                <div className='mx-auto my-1 text-zinc-500'>
                  {selectedAudio ? (
                    <div> - {selectedAudio.split("/")[2]}</div>
                  ) : (
                    <span>No saved preset</span>
                  )}
                </div>
                <button onClick={handleFocusPopup} className="mt-1.5 flex w-full items-center justify-center gap-1.5 bg-zinc-800/50 px-2 py-1.5 text-xs uppercase tracking-wider text-zinc-500 hover:bg-zinc-600/40 hover:text-zinc-300">
                  <AddIcon />
                  New Preset
                </button>
              </div>
            </div>
          )}

          <button className='flex items-center px-2 text-sm text-zinc-500 hover:bg-zinc-800'>
            <CopyIcon />
            <span className='hidden ml-1 sm:inline'>Copy URL</span>
          </button>
          <div className='flex items-center px-2 text-sm transition-all duration-200 text-zinc-100'>
            {format ? (
              <div>
                <span className='tabular-nums'>{formatTime(time, getCurrentLocationOffset(), false).hour}</span>
                <span className='mx-0.5 animate-show-hide font-serif'>:</span>
                <span className='tabular-nums'>{formatTime(time, getCurrentLocationOffset(), false).minute}</span>
                <span className='ml-1 text-gray-500'>{formatTime(time, getCurrentLocationOffset(), false).period}</span>
              </div>
            ) : (
              <div>
                <span className='tabular-nums'>{formatTime(time, getCurrentLocationOffset(), true).hour}</span>
                <span className='mx-0.5 animate-show-hide font-serif'>:</span>
                <span className='tabular-nums'>{formatTime(time, getCurrentLocationOffset(), true).minute}</span>
              </div>
            )}
          </div>
          <button onClick={() => setFormat(!format)} className="relative inline-block w-12 mx-auto font-sans text-sm font-medium transition-colors duration-300 text-neutral-400 bg-zinc-800 hover:bg-zinc-700">
            {format ? (
              <div>
                <span className="tabular-nums">12</span>
                <span className="ml-[2px] font-medium">hr</span>
              </div>
            ) : (
              <div>
                <span className="tabular-nums">24</span>
                <span className="ml-[2px] font-medium">hr</span>
              </div>
            )}
          </button>
        </div>
      </div >
    </>
  );
}

export default TopBar;
